import React from 'react'

export default function NotFound() {
  return (
    <div>La ruta no existe</div>
  )
}
